import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Agent {
  id: string;
  name: string;
  extension: string;
  status?: string;
  state?: string;
}

interface AgentsState {
  items: Agent[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: AgentsState = {
  items: [],
  status: "idle",
  error: null,
};

const agentsSlice = createSlice({
  name: "agents",
  initialState,
  reducers: {
    setAgents: (state, action: PayloadAction<Agent[]>) => {
  state.items = action.payload.map(agent => {
    const normalizedId = agent.id.trim().toLowerCase();
    const name = agent.name?.trim();

    return {
      ...agent,
      id: normalizedId,
      name: name && name.length > 0 ? name : `Agent (${agent.extension || 'N/A'})`,
      extension: agent.extension?.trim() || '—',
      status: agent.status?.trim() || "Available",
      state: agent.state?.trim() || "Unknown",
    };
  });
  state.status = "succeeded";
  state.error = null;
},


    updateAgentStatus: (
  state,
  action: PayloadAction<{ id?: string; status?: string; state?: string }>
) => {
  const rawId = action.payload.id;
  if (!rawId) {
    console.warn("❌ Missing agent ID in updateAgentStatus:", action.payload);
    return;
  }

  const idToMatch = rawId.trim().toLowerCase();
  const agent = state.items.find(a => a.id === idToMatch);

  if (agent) {
    agent.status = action.payload.status?.trim() || agent.status;
    agent.state = action.payload.state?.trim() || agent.state;
  } else {
    console.warn("❌ Agent not found for update:", idToMatch);
  }
},


    setAgentsLoading: (state) => {
      state.status = "loading";
      state.error = null;
    },
    setAgentsError: (state, action: PayloadAction<string>) => {
      state.status = "failed";
      state.error = action.payload;
    },
    resetAgents: (state) => {
      state.items = [];
      state.status = "idle";
      state.error = null;
    },
  },
});

export const {
  setAgents,
  updateAgentStatus,
  setAgentsLoading,
  setAgentsError,
  resetAgents,
} = agentsSlice.actions;

export default agentsSlice.reducer;
